import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../redux/settings/selectors";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { selecttenantDomainFunctionsListItems } from "../../../../../redux/TenantDomainFunctions/selector";
import { tenantDomainFunctions } from "../../../../../redux/TenantDomainFunctions/action";

const TenantDomainFunctions = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
	const { header, footer, currency } = result
    const tenantItems = useSelector(selecttenantDomainFunctionsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Id', headerName: 'Function Id', sortable: true, filter: true },
          { field: 'FunctionName', headerName: 'Function Name', searchField: 'FunctionName', filter: true,
            filterType: 'text'  },
          { field: 'FeatureName', headerName: 'Feature Name', searchField: 'FeatureName', filter: true,
            filterType: 'text'  },
          { field: 'DomainName', headerName: 'Domain Name', sortable: true, filter: true },
          { field: 'Code', headerName: 'Code', searchField: 'Code', filter: true,
            filterType: 'text'  },
          { field: 'HasFolder', headerName: 'HasRootFolder',cellRenderer: 'yesNoRenderer'},
          { field: 'IsActive', headerName: 'Active ',cellRenderer: 'yesNoRenderer' },
          { field: 'IsParent', headerName: 'Parent ' ,cellRenderer: 'yesNoRenderer'},
        ]);
      }

      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(tenantDomainFunctions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/list`,entity:'tenantDomainFunctions',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
          }}))
      }
    
      const handleSelect = (item: any, checked: any) => {
        console.log("Item", checked, item)
      }
    
      const handleSelectAll = (items: any[], checked: any) => {
        console.log("Items count", checked, items?.length)
        console.log('items', items)
      }

      const handleReloadData = () => {
        dispatch(tenantDomainFunctions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/list`,entity:'tenantDomainFunctions',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
     
      const handleEdit=(data: any)=>{
        navigate(`${data?.Id}`)
      }
        
      const fetchTenantDomainFunctions=()=>{
        dispatch(tenantDomainFunctions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/list`,entity:'tenantDomainFunctions',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "FunctionName",
        "SortOrder": "desc",
        
    
        }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchTenantDomainFunctions()
	}, [pageData,pageSize])
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Function</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Add Product',
      callback: () => handleAdd(),
    },
    {
      svg:
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
      <title>Reload</title>
      <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>,
    // name: 'Reload',
    callback: () => handleReloadData(),
    },
  ];

  const handleDelete=(data: any)=>{
    dispatch(tenantDomainFunctions.delete({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/delete`,
      entity: 'tenantDomainFunctions',
      jsonData: {
        Records: [
          {
         
                Id: data?.Id
            }
          
        ]
      }
  })).then(() => {
    dispatch(tenantDomainFunctions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/list`,entity:'tenantDomainFunctions',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": pageSize,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
  });
  }
	return (
    <>
    {tenantItems?.isLoading ?  <PageLoader />: 
		<Table   enableFilter={true}
    filterTypeLists={filterTypes}
    onSearch={handleSearch} columnData={columnDefs} rowData={tenantItems?.result?.items} setPageData={setPageData}
    setPageSize={setPageSize}paginationData={tenantItems?.result?.pagination} onEdit={handleEdit}  onDelete={handleDelete} additionButtons={additionButtons} headingName="Functions"/>
     
  }
  </> 
	);
};

export default TenantDomainFunctions;


